import { PlaylistMusicIcon } from './PlaylistMusicIcon';

/**
 * author: Google
 * id F7BFD179-3B1E-4347-BD64-C51686B00E65
 * name playlist-music
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/playlist-music.svg
 * tags
 * - Music 
 */
export const QueueMusicIcon = PlaylistMusicIcon;
export default QueueMusicIcon